import type { PageLoadMetric } from '../metric/page-load-metric';
import type { Metric, PageSegmentLoadMetric } from '../types';

import { concurrent } from './concurrent';
import { custom, interaction, pageLoad, pageSegmentLoad } from './core';
import type { CustomPerformanceEventFactoryConfig, InteractionPerformanceEventFactoryConfig, PageLoadPerformanceEventFactoryConfig, PageSegmentLoadPerformanceEventFactoryConfig } from './types';

/**
 * @deprecated use ufo: go/ufo
 */
export const metrics: {
    pageLoad: (config: PageLoadPerformanceEventFactoryConfig) => PageLoadMetric; pageSegmentLoad: (config: PageSegmentLoadPerformanceEventFactoryConfig) => PageSegmentLoadMetric; interaction: (config: InteractionPerformanceEventFactoryConfig) => Metric; custom: (config: CustomPerformanceEventFactoryConfig) => Metric; concurrent: {
        pageSegmentLoad: (config: PageSegmentLoadPerformanceEventFactoryConfig) => (concurrentId: string | number) => Metric;
        interaction: (config: InteractionPerformanceEventFactoryConfig) => (concurrentId: string | number) => Metric;
        custom: (config: CustomPerformanceEventFactoryConfig) => (concurrentId: string | number) => Metric;
    };
} = {
	pageLoad,
	pageSegmentLoad,
	interaction,
	custom,
	concurrent,
};
